// extracted by mini-css-extract-plugin
export default {"resLoading":"resLoading_dYN8i8","loading":"loading_NsSCJA","rotate":"rotate_+K0XtC","loadingText":"loadingText_fhG37v"};